import React, { Component } from "react"
import notificationStore from "../notificationStore"
import "./Alarm.css"

interface AlarmProps {
    notificationCount: number
}

class Alarm extends Component<AlarmProps> {

    render() {

        const props = this.props

        return (
            <div className="Alarm">
                <div className="Alarm-Wrapper">
                    <span className="material-icons" onClick={() => notificationStore.manageState([{ key: "notificationMenuOpen" }])}>notifications</span>
                    {props.notificationCount > 0 && <div className="Notification-Badge">
                        <p onClick={() => notificationStore.manageState([{ key: "notificationMenuOpen" }])}>{props.notificationCount}</p>
                    </div>}
                </div>
            </div>
        )
    }
}

export default Alarm